import { render, staticRenderFns } from "./home-id.vue?vue&type=template&id=86e4d9ec&scoped=true"
import script from "./home-id.vue?vue&type=script&lang=js"
export * from "./home-id.vue?vue&type=script&lang=js"
import style0 from "./home-id.vue?vue&type=style&index=0&id=86e4d9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e4d9ec",
  null
  
)

export default component.exports